module.exports = {"name":"--pf-global--breakpoint--2xl","value":"1450px","var":"var(--pf-global--breakpoint--2xl)"}
